import React from "react";
import { NavLink } from "react-router-dom";
import { NAV_ITEMS, MOBILE_PRIMARY } from "./navConfig";

export default function MobileNav() {
  const items = NAV_ITEMS.filter((i) => MOBILE_PRIMARY.includes(i.to));
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-white/8 bg-[#0a0a0b]/90 backdrop-blur-xl lg:hidden" data-testid="mobile-nav">
      <div className="flex items-stretch justify-around px-2 py-2">
        {items.map((item) => (
          <NavLink key={item.to} to={item.to}
            className={({ isActive }) => `flex flex-1 flex-col items-center gap-1 rounded-xl py-1.5 transition-colors ${isActive ? "text-white" : "text-neutral-500"}`}
            data-testid={`bottom-nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}>
            {({ isActive }) => (
              <>
                <item.icon size={19} />
                <span className="font-mono text-[9px] uppercase tracking-wider">{item.label}</span>
                {isActive && <span className="h-0.5 w-4 rounded-full bg-silver" />}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
